import isEmpty from 'lodash/isEmpty'

const countNumber = str => {
  const pattern = /[^0-9]/
  return str.replace(pattern, '').length
}

export default (type = null) => {
  // eslint-disable-next-line no-console
  const phonePattern = /^((8|\+7)[\- ]?)?(\(?\d{3}\)?[\- ]?)?[\d\- ]{7,10}$/
  // eslint-disable-next-line no-console
  const emailPattern = /.+@.+\..+/i

  switch (type) {
    case 'strLength':
      return (val, length = 0) => val.length >= length
    case 'empty':
      return val => !isEmpty(val)
    case 'phone':
      return (val, isEmptyVal = false) => (isEmpty(val) && isEmptyVal) ||
        val.search(phonePattern) !== -1
    case 'email':
      return (val, isEmptyVal = false) => (isEmpty(val) && isEmptyVal) ||
        val.search(emailPattern) !== -1
    case 'countNumber':
      return (val, count = 10) => countNumber(val) === count && val.length === count
    case 'countNumberRange':
      return (val, payload) => {
        const countNum = countNumber(val)
        return countNum >= payload.start
          && countNum <= payload.end
          && countNum === val.length
      }
    default:
      return () => true
  }
}



// WEBPACK FOOTER //
// ./src/utils/validation.js